

export const priceSourceMap = {
    "Uwagi na fakturach na fakturach zakupu": 5,
        "Plik CSV": 1,
        "ID cennika w Kamsoft AOW": 2,
        "Wybrany dokument zakupu": 3,
        "Wybrany dostawca": 4,
        "Wybrana grupa asortymentowa": 6,
};

export const priceStrategyTaskFormFields =  {

    priceStrategyTaskMainForm:  [
        {
            order: 0,
            rowClass: "row",

            name: "row-10-pstmf",
            fields: [
                {
                    order: 0,
                    name: "price-strategy-task-config-title-section",
                    value:
                        "Wypełnij poniższe pola, aby dodać nową strategię cenową. Pola oznaczone gwiazdką są wymagane.",
                    type: "section",
                    label: "",
                    required: false,
                    colClass: "col",
                },
            ],
        },
        {
            order: 0,
            rowClass: "row",
            name: "row-0-pstmf",
            fields: [
                {
                    order: 0,
                    name: "name", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Nazwa",
                    required: true,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 100, // used only to validate text fields
                    pattern: "^[a-zA-Z0-9\\s]{1,}$",
                    placeholder: "Wpisz nazwę raportu",
                    helpText:
                        "Uzupełnij nazwę raportu. Pole musi zawierać od 3 do 100 znaków",
                    colClass: "col col-lg-6",
                },
                {
                    order: 0,
                    name: "active",
                    value: null,
                    type: "checkbox",
                    label: "Aktywny",
                    required: false,
                    options: [],
                    helpText: "Kliknij, aby aktywować strategię",
                    colClass: "col col-lg-3",
                },
            ],
        },

        {
            order: 0,
            rowClass: "row",
            name: "row-1-pstmf",
            fields: [
                {
                    order: 0,
                    name: "description",
                    value: "",
                    type: "textarea",
                    label: null,
                    required: false,
                    options: [],
                    minLength: 0,
                    maxLength: 250,
                    pattern: "^[a-zA-Z0-9\\s]{1,}$",
                    placeholder: "Dodaj opis strategii (opcjonalne)",
                    helpText:
                        "Możesz dodać opis raportu. Pole musi zawierać od 0 do 250 znaków",
                    colClass: "col",
                },
            ],
        },

        {
            order: 0,
            rowClass: "row",
            name: "row-2-pstmf",
            fields: [
                {
                    order: 0,
                    name: "type",
                    value: null,
                    type: "select",
                    label: "Typ strategii",
                    required: true,
                    options: ["PRICELIST"],
                    placeholder: "Wybierz typ strategii",
                    helpText: "Wybierz z listy możliwych typów",
                    colClass: "col col-lg-6",
                },
                {
                    order: 0,
                    name: "changeRetailPricesDirectly",
                    value: null,
                    type: "checkbox",
                    label: "Czy zmieniać ceny na bezpośrdnio na kartotekach zakupowych?",
                    required: false,
                    options: [],
                    helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                    colClass: "col col-lg-6",
                },
            ],
        },

        {
            order: 0,
            rowClass: "row",
            name: "row-3-pstmf",
            fields: [
                {
                    order: 0,
                    name: "bottomMarginLimit",
                    value: 0.0,
                    type: "number",
                    label: "Min. marża na produktach",
                    required: false,
                    options: [],
                    minValue: 0.0,
                    maxValue: 100.0,
                    placeholder: "Wybierz min. marżę",
                    helpText: "Ustawienie minimalnej marża na produktach, sprawi że produkty o zbyt niskiskiej marży po zmianach zostaną pominięte i pozostaną z ceną pierwotną.",
                    colClass: "col col-lg-6",
                },
                {
                    order: 0,
                    name: "upperMarginLimit",
                    value: 1000.0,
                    type: "number",
                    label: "Maks. marża na produktach",
                    required: false,
                    options: [],
                    minValue: 0.0,
                    maxValue: 100.0,
                    placeholder: "Wybierz maks. marżę",
                    helpText: "Ustawienie maksymalnej marży na produktach, sprawi że produkty o zbyt byt wysokiej marży po zmianach zostaną pominięte i pozostaną z ceną pierwotną.",
                    colClass: "col col-lg-6",
                },

            ],
        },

    ],
    priceStrategyTaskDrugstoreForm: [
        {
            order: 0,
            rowClass: "row",

            name: "row-10-pstdf",
            fields: [
                {
                    order: 0,
                    name: "price-strategy-task-drugstores-title-section",
                    value:
                        "Wybierz apteki, objęte zmianą cen.",
                    type: "section",
                    label: "",
                    required: false,
                    colClass: "col",
                },
            ],
        },
        {
            order: 0,
            rowClass: "row",
            name: "row-0-pstdf",
            fields: [

                {
                    order: 0,
                    name: "drugstoresClientIds",
                    value: null,
                    type: "slot",
                    label: "Lista aptek",
                    required: false,
                    options: [],
                    helpText: "Lista aptek, objętych zmianą cen",
                    colClass: "col",
                },
            ],
        },

    ],
    priceStrategyTaskProductForm: [],
    priceStrategyTaskListSourceForm: [
        {
            order: 0,
            rowClass: "row",
            name: "row-1-pstlsf",
            fields: [
                {
                    order: 0,
                    name: "type",
                    value: null,
                    type: "select",
                    label: "Rodzaj źródła cen",
                    required: false,
                    // 1 - csv,2 - cnkn, 3- dokf, 4- dost, 5- uwagi, 6- grpn
                    options: Object.keys(priceSourceMap),
                    placeholder: "Wybierz typ strategii",
                    helpText: "Wybierz z listy możliwych typów",
                    colClass: "col",
                },

            ],
        },
        {
            order: 1,
            rowClass: "row",
            name: "row-2-pstlsf",
            fields: [
                {
                    order: 0,
                    name: "sourceDocumentNotes",
                    value: null,
                    type: "text",
                    label: "Wyszukiwana fraza",
                    required: false,
                    // 1 - csv,2 - cnkn, 3- dokf, 4- dost, 5- uwagi, 6- grpn
                    options: Object.keys(priceSourceMap),
                    placeholder: "Wpisz frazę",
                    helpText: "Wpisz tutaj frazę, na podstawie, której zostaną wyszukane dokumenty zakupu, których ceny zostaną poprawione. Możesz wpisać tylko jedną frazę.",
                    colClass: "col col-lg-6",
                },
                {
                    order: 0,
                    name: "numberOfDaysBackwardsToCheckDocumentNotes",
                    value: null,
                    type: "number",
                    label: "Ilość dni wstecz",
                    required: false,
                    options: [],
                    minValue: 0,
                    maxValue: 90,
                    placeholder: "Wpisz ilość dni",
                    helpText: "Ilość dni wstecz, na ile będą sprawdzane faktury zakupu w aptece wzorcowej. Jeśli nie zostanie wpisana żadna wartość, to sprawdzane będą faktury zakupu na 30 dni wstecz.",
                    colClass: "col col-lg-6",
                },

            ],
        },
        {
            order: 2,
            rowClass: "row",
            name: "row-3-pstlsf",
            fields: [
                {
                    order: 0,
                    name: "filterRxProducts",
                    value: null,
                    type: "checkbox",
                    label: "Pomiń produkty RX",
                    required: false,
                    options: [],
                    helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                    colClass: "col col-lg-3",
                },
                {
                    order: 0,
                    name: "filterOtcProducts",
                    value: null,
                    type: "checkbox",
                    label: "Pomiń produkty OTC",
                    required: false,
                    options: [],
                    helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                    colClass: "col col-lg-3",
                },
                {
                    order: 0,
                    name: "filterNfzProposalProducts",
                    value: null,
                    type: "checkbox",
                    label: "Pomiń produkty na Wniosek",
                    required: false,
                    options: [],
                    helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                    colClass: "col col-lg-3",
                },
                {
                    order: 0,
                    name: "filterRecProducts",
                    value: null,
                    type: "checkbox",
                    label: "Pomiń produkty recepturowe",
                    required: false,
                    options: [],
                    helpText: "Zanzacz tę opcję jeśli się zgadzasz",
                    colClass: "col col-lg-3",
                },

            ],
        },
        {
            order: 3,
            rowClass: "row",
            name: "row-4-pstlsf",
            fields: [
                {
                    order: 0,
                    name: "priceSourceDrugstoreClientId",
                    value: null,
                    type: "text",
                    label: "Numer apteki wzorcowej",
                    required: true,
                    pattern: "^[0-9]{6}$",
                    options: [],
                    placeholder: "Wpisz 6-cyfrowy numer apteki",
                    helpText: "Numer apteki to 6-cyfrowy numer, który stanowi jednocześcnie numer licencji Kamsoft AOW.",
                    colClass: "col col-lg-3",
                },

            ],
        },
    ],
}


